import InvoiceLayout from '../../utils/InvoiceLayout';
import TopLeftCol from './Components/TopLeftCol';
import InvoiceBreakdownSection from './InvoiceBreakdownSection';
import InvoiceDataTable from './InvoiceDataTable';
import './invoice.style.css';

function Header({ info }) {
    return (
        <>
            <div className="flex justify-between mb-5 min-h-[20px] max-h-[300px] px-[73px] pt-3 print:pt-0">
                <TopLeftCol info={info} />
            </div>
            <div className="w-full px-[38px]">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="1"
                    viewBox="0 0 1000 1"
                    fill="none"
                >
                    <path d="M0 0.5H1000" stroke="#E54253" />
                </svg>
            </div>
        </>
    );
}

// function Footer() {
//     // function Footer({ info }) {
//     const { headerLessPrint } = useInvoiceInfo();
//     if (headerLessPrint) {
//         return null;
//     }
// return (
//     <div className="fixed! -bottom-12 left-0 w-full hidden! print:block">
//         <img src={invFooterImg} alt="" className="w-full" />
//     </div>
// );
// return (
//     <div className="fixed bottom-0 w-full mt-20 pt-20 hidden print:block print:h-auto print:min-h-0">
//         {/* <SignatureArea info={info} /> */}
//         <div className="flex items-end justify-between gap-2">
//             <div className="w-[280px] h-[28px]">
//                 <img src={footerBottomImg} alt="Footer Dialog" className="w-full h-full" />
//             </div>

//             <div className="flex items-center justify-end mb-4.5 mr-8 gap-6">
//                 <div className="footer_address text-left flex flex-col gap-[2.5px] w-[1]">
//                     <h1 className="text-invoice-primary text-[8px]">Address</h1>
//                     <p className="text-[10px] text-[#555555] leading-[14px]">
//                         2521/34 Ladprao Road, <br />
//                         Khlongchaokhunsing, Wangthongle <br />
//                         Bangkok 10310, Thailand
//                     </p>
//                 </div>
//                 <div className="footer_address_contact text-left flex flex-col gap-[2.5px]">
//                     <h1 className="text-invoice-primary text-[8px]">Contact</h1>
//                     <p className="text-[10px] text-[#555555] leading-[14px]">
//                         Tel : +66 2514-0314-7
//                         <br />
//                         Fax : +66 2514-0328 <br />
//                         Email : mirasales@gmail.com
//                     </p>
//                 </div>
//             </div>
//         </div>
//     </div>
// );
// }

function InvoiceView({ info, isHeaderLessPrint }) {
    // const paidOrPartial =
    //     info?.invoice.amountDue === 0 ? (
    //         <div className="paid-view border-success text-success">PAID</div>
    //     ) : (
    //         <div className="paid-view border-warning text-warning"> PARTIAL</div>
    //     );

    return (
        <div className="flex justify-center relative z-10">
            <InvoiceLayout isHeaderLessPrint={isHeaderLessPrint}>
                <Header info={info} />
                <div className="px-[73px] pt-3 min-h-[200px] relative z-10 mb-6">
                    <InvoiceDataTable info={info} />
                </div>

                <div className="px-[46px] relative print:break-inside-avoid ">
                    {/* Invoice Breakdown Section */}
                    <InvoiceBreakdownSection info={info} />
                </div>
            </InvoiceLayout>
        </div>
    );
}

export default InvoiceView;
